import React from "react";
import CallsLayout from "../common/CallLayout.jsx";
//import Calls from "./tabCalls.jsx";
import OutboundVoicemail from "./VoicemailCalls.jsx";
import CustomerNotes from "../common/TabNotes.jsx";
import CustomerProfile from "../common/TabProfile.jsx";
import CustomerHistory from "../common/TabHistory.jsx";
import CustomerTexts from "../common/TabTexts.jsx";
import CustomerCallsHistory from "../common/TabCallsHistory.jsx";
import CustomerEmails from "../common/TabEmails.jsx";
import CustomerDataset from "../common/TabDataset.jsx";
import SearchCustomer from "../incoming/SearchCustomer.jsx";
import CustomerChats from "../common/TabChats.jsx";
import VoiceMailCalls from "./VoicemailCalls.jsx";
import SendText from "../common/SendText.jsx";
import SendEmail from "../common/SendEmail.jsx";
import AddRelatedRecord from "../common/AddRelatedRecord.jsx";

const VoiceMailLayout = () => {
  const [customerGuid, setCustomerGuid] = React.useState(null);
  const [customerId, setCustomerId] = React.useState(null);
  const [callConnectionId, setCallConnectionId] = React.useState(null);
  const [refreshOutgoing, setRefreshOutgoing] = React.useState(false);

  const triggerRefreshOutgoingCalls = () => {
    setRefreshOutgoing((prev) => !prev); // toggles the value to trigger useEffect in child
  };
  const tabs = [
    {
      label: "Conversation",
      value: "Conversation",
      component: <div>Conversation</div>,
    },
    {
      label: "Profile",
      value: "Profile",
      component: (
        <CustomerProfile
          customerguid={customerGuid}
          callConnectionId={callConnectionId}
          onRefreshOutgoingCalls={triggerRefreshOutgoingCalls}
        />
      ),
    },
    {
      label: "Dataset",
      value: "Dataset",
      component: <CustomerDataset customerguid={customerGuid} />,
    },
    {
      label: "Notes",
      value: "Notes",
      component: <CustomerNotes customerguid={customerGuid} />,
    },
    {
      label: "History",
      value: "History",
      component: <CustomerHistory customerguid={customerGuid} />,
    },
    { label: "Payments", value: "Payment", component: <div>Payment</div> },
    {
      label: "Calls",
      value: "Calls",
      component: <CustomerCallsHistory customerguid={customerGuid} />,
    },
    {
      label: "Chats",
      value: "Chat",
      component: <CustomerChats customerguid={customerGuid} />,
    },
    {
      label: "Texts",
      value: "Texts",
      component: <CustomerTexts customerguid={customerGuid} />,
    },
    {
      label: "Emails",
      value: "Emails",
      component: <CustomerEmails customerguid={customerGuid} />,
    },
  ];

  const handleSelectedCustomer = (guid, id, callConnectionId) => {
    setCustomerGuid(guid);
    setCustomerId(id);
    setCallConnectionId(callConnectionId);
  };

  const handleGuid = (guid) => {
    if (guid) {
      setCustomerGuid(guid);
    }
  };

  const menuAction = [];
  if (customerGuid) {
    menuAction.push(
      {
        component: <SendText customerguid={customerGuid} />,
      },
      {
        component: <SendEmail customerguid={customerGuid} />,
      },
      {
        component: <AddRelatedRecord customerguid={customerGuid} />,
      }
    );
  }
  if(!customerGuid && customerId){
    menuAction.push(
      {
        component: <SearchCustomer onCustomerGuid={handleGuid} />,
      })
  }

  return (
    <CallsLayout
      leftPanel={
        <VoiceMailCalls
          onCustomerGuid={handleSelectedCustomer}
          refreshTrigger={refreshOutgoing}
        />
      }
      tabConfig={customerGuid ? tabs : null}
      menuActions={menuAction}
      defaultTab="Profile"
      title="Customer Information"
    />
  );
};

export default VoiceMailLayout;
